import {ref} from "vue"
import store from '@/store'
import {toastController} from '@ionic/vue';

const data = ref<any>(null)

export default function LessonsService () {

    async function  openToastOptions(data, color = 'success') {
        const toast = await toastController.create({
            color: color,
            duration: 2000,
            message: data,
        });
        await toast.present();
    }

    const fetchLessons = () => {
        return store
            .dispatch('lessons/fetchLessons', {
                "class_id": JSON.parse(localStorage.getItem('currentClass') || '{}').id
            })
            .catch(error => {
                console.log(error.response)
                if (error.response.status != 422) {
                    openToastOptions('Impossibile caricare le lezioni', 'danger')
                }
            })
    }

    const getCurrentLessons = () => store.getters['lessons/getListLessons']

    return {
        data,
        getCurrentLessons,
        fetchLessons,
    }
}